import * as React from 'react'
import { Link } from 'react-navi'

import './list.scss'
import RankCircleIcon from '../../../images/rank_circle.png'
import MoreIcon from '../../../images/more.png'

import { CheckAuth } from '../../../utils/auth'
import { modalPS } from '../../common/modal/modal'
import { ModalState } from '../../common/voting/voting'
import { IProps } from './interface'
import { IActivityDetailRes, IActivityRankRes } from '../interface'

class List extends React.Component<IProps> {
    public render = () => {
        const { activityId, detail, options } = this.props.data
        return (
            <ul className="activity-rank-list">
                {options.map(item => {
                    return <li className="list-item" key={item.id}>
                        <div className="top">
                            <Link className="name" href={`/detail/${activityId}/info/${item.id}`}>
                                <div className="text">{item.name}</div>
                            </Link>
                            <div className="rank">
                                <img className="icon" src={RankCircleIcon} />
                                <span>{item.voteNum}</span>
                            </div>
                        </div>
                        <div className="bottom">
                            {<div>
                                {item.voteAvatarUrlList.length > 5 ?
                                    item.voteAvatarUrlList.map((url, index) => {
                                        return index < 4 && <img className="avatars-item" key={index} src={url} />
                                    }) :
                                    item.voteAvatarUrlList.map((url, index) => {
                                        return <img className="avatars-item" key={index} src={url} />
                                    })}
                                {item.voteAvatarUrlList.length > 5 && <img className="avatars-item" src={MoreIcon} />}
                            </div>}
                            {detail.deadline > (new Date().getTime() / 1000) ?
                                <button className="button" onClick={this.vote.bind(this, item.id)}>投票</button> :
                                <button className="button disabled">投票</button>
                            }
                        </div>
                    </li>
                })}
            </ul>
        )
    }

    private vote = (optionId: number) => {
        const { activityId } = this.props.data
        CheckAuth.check()
        modalPS.show({
            VoteID: activityId.toString(),
            OptionID: optionId.toString(),
            Callback: (...res: any[]) => {
                const detail: IActivityDetailRes & IActivityRankRes = res[0]
                const currentStatus: ModalState = res[1]
                if (currentStatus === ModalState.Voting) {
                    this.props.updateActivityDetailAndOptionItem(detail)
                }
            }
        })
    }
}

export {
    List
}


// WEBPACK FOOTER //
// ./src/components/activity_rank/list/list.tsx